/**
 * What a program card is called, in the two places a name is needed.
 *
 * A card face is `--card-w` wide -- 3.5rem -- so a name drawn ON a card
 * has to fit it, and the glyph and priority beside it already say which
 * way the robot turns. A name in a SENTENCE has room and needs the verb:
 * the log writes "Ratchet plays Rotate Left (priority 90)", where a bare
 * "Left" reads as a fragment.
 *
 * Only the two rotations differ, so the long map overrides that pair.
 */

/** On a card face, a register slot, or the strip. Short enough to fit. */
export const CARD_LABEL: Record<string, string> = {
  UTurn: 'U-Turn',
  RotateLeft: 'Left',
  RotateRight: 'Right',
  BackUp: 'Back Up',
  Move1: 'Move 1',
  Move2: 'Move 2',
  Move3: 'Move 3',
};

/** In prose -- the log, and anywhere a card is named in a sentence. */
export const CARD_LABEL_LONG: Record<string, string> = {
  ...CARD_LABEL,
  RotateLeft: 'Rotate Left',
  RotateRight: 'Rotate Right',
};
